// src/components/layouts/Footer.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";
import logo from "../../assets/logoavena.png";
import { FaWhatsapp } from "react-icons/fa";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaLocationDot,
  FaEnvelope,
  FaPhone,
  FaInstagram,
} from "react-icons/fa6";
import axios from "axios";

const API = "https://api.ainfotech.com.np"; 

export default function Footer() {
  const year = new Date().getFullYear();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch services from backend
  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/api/services?status=published&page=1&limit=10`);
        setServices(res.data.items || []);
      } catch (err) {
        console.error("Failed to fetch services:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <footer className="avena-footer">
      <div className="avena-footer__top">
        <div className="container">
          <div className="row gy-4">
            {/* Brand + blurb */}
            <div className="col-12 col-lg-4">
              <Link to="/" className="d-inline-flex align-items-center mb-3">
                <img src={logo} alt="Avena Info Tech" className="avena-footer__logo" />
              </Link>
              <p className="avena-footer__blurb">
                Smart &amp; Simple IT Solutions — secure software, dependable hardware,
                and on-time support for fast-moving businesses.
              </p>

              <div className="d-flex gap-2 avena-footer__social">
                <a
                  href="https://www.facebook.com/people/Avena-InfoTech-PvtLtd/61574640069678/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="btn btn-sm avena-footer__socialBtn"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.instagram.com/avenainfotech"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="btn btn-sm avena-footer__socialBtn"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.linkedin.com/company/avena-infotech-pvt-ltd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="btn btn-sm avena-footer__socialBtn"
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-6 col-lg-2">
              <h6 className="avena-footer__heading">Quick Links</h6>
              <ul className="list-unstyled avena-footer__links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/servicespage">Services</Link></li>
                <li><Link to="/contact">Support</Link></li>
                <li><Link to="/careers">Careers</Link></li>
              </ul>
            </div>

            {/* Services fetched dynamically */}
            <div className="col-6 col-lg-3">
              <h6 className="avena-footer__heading">Services</h6>
              <ul className="list-unstyled avena-footer__links">
                {loading ? (
                  <li>Loading...</li>
                ) : services.length > 0 ? (
                  services.slice(0, 6).map((s) => (
                    <li key={s.id}>
                      <Link to={`/servicespage#${encodeURIComponent(s.slug || s.id)}`}>
                        {s.title}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>No services available</li>
                )}
              </ul>
            </div>

            {/* Contact */}
            <div className="col-12 col-lg-3">
              <h6 className="avena-footer__heading">Contact</h6>
              <ul className="list-unstyled avena-footer__contact">
                <li>
                  <span className="avena-footer__icon" aria-hidden="true">
                    <FaLocationDot />
                  </span>
                  <span>Banasthali-16, Kathmandu, Nepal</span>
                </li>
                <li>
                  <span className="avena-footer__icon" aria-hidden="true">
                    <FaEnvelope />
                  </span>
                  <a href="mailto:support@ainfotech.com.np">support@ainfotech.com.np</a>
                </li>
                <li>
                  <span className="avena-footer__icon" aria-hidden="true">
                    <FaPhone />
                  </span>
                  <a href="tel:+9779800000000">+977 9841126140</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/9779841126140?text=Hello%20Avena%20Info%20Tech!%20I%20would%20like%20to%20know%20more%20about%20your%20services."
        className="avena-footer__whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </a>

      {/* Bottom bar */}
      <div className="avena-footer__bottom">
        <div className="container d-flex flex-column flex-md-row align-items-center justify-content-center gap-2">
          <small className="mb-0">© {year} Avena Info Tech. All rights reserved.</small>
          {/* <ul className="list-inline mb-0 avena-footer__policies">
            <li className="list-inline-item"><Link to="/privacy">Privacy</Link></li>
            <li className="list-inline-item"><Link to="/terms">Terms</Link></li>
            <li className="list-inline-item"><Link to="/cookies">Cookies</Link></li>
          </ul> */}
        </div>
      </div>
    </footer>
  );
}
